module.exports = __webpack_public_path__ + "static/img/body_bg.807ac464.png";